import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserTournamentMatch')
export class UserTournamentMatch {

  @JsonProperty('match_number', Number)
  matchNumber: number = 0;

  @JsonProperty('match_id', Number)
  matchId: number = 0;

  @JsonProperty('score', Number)
  score: number = 0;
}
